var $67a737c7c33db7eb$exports = {};
$67a737c7c33db7eb$exports = {
    "pending": `\u{4FDD}\u{7559}`
};


export {$67a737c7c33db7eb$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
